module.exports = __webpack_public_path__ + "static/project6-1afd506ce7941abd0977d90894a735c1.jpg";